export const SITE_URL: string =
  (import.meta.env.VITE_SITE_URL as string | undefined) || "https://usfanslink.asia";

export const LOGO_URL: string =
  "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2277e9ffbdee9fd651886f1aeeba0d56.jpeg";

const publisher = {
  "@type": "Organization",
  name: "USFansLink",
  url: SITE_URL,
  logo: {
    "@type": "ImageObject",
    url: LOGO_URL,
  },
};

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "USFansLink",
  alternateName: "USFans Spreadsheet Resource Center",
  url: `${SITE_URL}/`,
  description:
    "An independent resource hub for the USFans Spreadsheet with updated guides, reviews, shipping, warehouse and safety information.",
  inLanguage: ["en", "pl", "es", "fr"],
  publisher,
};

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "USFansLink",
  url: `${SITE_URL}/`,
  logo: {
    "@type": "ImageObject",
    url: LOGO_URL,
  },
};

export interface ArticleSchemaInput {
  title: string;
  description: string;
  image: string;
  slug: string;
}

export function articleSchema({
  title,
  description,
  image,
  slug,
}: ArticleSchemaInput) {
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: title,
    description,
    image: [image],
    author: {
      "@type": "Organization",
      name: "USFansLink",
      url: `${SITE_URL}/`,
    },
    publisher,
    datePublished: "2026-08-23",
    dateModified: "2026-08-23",
    mainEntityOfPage: `${SITE_URL}/guide/${slug}`,
    inLanguage: "en",
  };
}

export function faqSchema(faqs: { q: string; a: string }[]) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: {
        "@type": "Answer",
        text: f.a,
      },
    })),
  };
}